import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { MuiOtpInput } from 'mui-one-time-password-input';
import { maskEmailAddress } from '../../../utils';
import { IEnterOTPProps } from '../../../constants/types';
import {
  OTP_INPUT_PLACEHOLDER,
  RESEND_TIMER_WARNING,
  CONFIRM_BUTTON_TEXT,
  OTP_TITLE,
  OTP_RESEND_TEXT,
} from '../../../constants';
import LoginRegistrationHeader from '../../../components/layout/LoginRegistrationHeader';

const EnterOTPComponent: React.FC<IEnterOTPProps> = ({
  handleOTPChange,
  email,
  handleSubmit,
  values,
  touched,
  errors,
  timer,
  isTimerActive,
  isButtonDisabled,
  handleResetOTP,
}) => {
  const maskedEmail = React.useMemo(() => maskEmailAddress(email), [email]);

  const validateChar = (char: string) => !Number.isNaN(Number(char));

  return (
    <form className="d-flex flex-column flex-1" onSubmit={handleSubmit}>
      <LoginRegistrationHeader />
      <Box pt={5} mb={7.75}>
        <Typography variant="h4" color="primary" mb={1.5}>
          {OTP_TITLE}
        </Typography>
        <Typography variant="body1">
          {OTP_INPUT_PLACEHOLDER.replace('{email}', maskedEmail)}
        </Typography>
      </Box>
      <MuiOtpInput
        value={values.otpCode}
        onChange={handleOTPChange}
        validateChar={validateChar}
        mb={2}
        gap={3}
        TextFieldsProps={{
          sx: { flex: 1 },
          error: touched?.otpCode && Boolean(errors?.otpCode),
          helperText: touched?.otpCode && errors?.otpCode,
        }}
      />
      <Button
        variant="text"
        sx={{ alignSelf: 'start' }}
        disabled={isTimerActive}
        onClick={handleResetOTP}
      >
        {OTP_RESEND_TEXT}{' '}
        {isTimerActive && RESEND_TIMER_WARNING.replace('{timer}', `${timer}`)}
      </Button>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 'auto', mb: 4.5 }}
        type="submit"
        disabled={isButtonDisabled}
      >
        {CONFIRM_BUTTON_TEXT}
      </Button>
    </form>
  );
};

export default EnterOTPComponent;
